<template>
    <div>
        <button @click="showModal" class="map-btn">Select from map</button>

        <!-- Custom Modal -->
        <div v-if="isModalVisible" class="custom-modal">
            <div class="modal-overlay" @click="hideModal"></div>
            <div class="modal-content">
                <GmapMap :options="mapOptions" :center='center' :zoom='12' style='width:640px;  height: 567px;'>
                    <GmapMarker :key="index" v-for="(m, index) in markers" :position="m.position" :clickable="false"
                        :draggable="false" @click="centerMap(m.position)" @drag="updateCoordinates" />
                </GmapMap>
            </div>
        </div>
        <!-- End of Custom Modal -->
    </div>
</template>
<script>
export default {
    data() {
        return {
            isModalVisible: false,
        };
    },
    methods: {
        showModal() {
            this.isModalVisible = true;
        },
        hideModal() {
            this.isModalVisible = false;
        },
    },
};

</script>  
<style lang="scss" scoped>
.custom-modal {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
}

.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 999;
}

.modal-content {
    background-color: #fff;
    padding: 20px;
    border-radius: 5px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
    z-index: 1000;
    max-width: 500px;
}

.modal-close-btn {
    background-color: #007bff;
    color: #fff;
    border: none;
    padding: 8px 16px;
    border-radius: 5px;
    cursor: pointer;
    margin-top: 20px;
}
</style>